
import {Component} from 'san';
import styles from './style/index.module.less';
import TtsBtn from '../ttsBtn';

export default class Header extends Component {
    static template = require('./index.html');
    static components = {
        'ui-tts-btn': TtsBtn
    };
    static computed = {
        itemData() {
            return this.data.get('data.itemData');
        },
        info() {
            return this.data.get('data.itemData.info');
        },
        infoB() {
            return this.data.get('data.itemData.infoBaiJiaHao');
        }
    };
    initData() {
        return {
            styles
        };
    }
    /* eslint-disable import/newline-after-import */
};
